import { OpenableCard, InfoWithAccordion } from '@hg/stylizator/components'
import { Text } from '@hg/stylizator/typography'
import parse from 'html-react-parser'
import * as React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import styled from 'styled-components'

import ClientOnly from 'app/components/ClientOnly'
import { IAttributes } from 'app/components/CustomBlocks/Section/InfoWithExpandableCardsSectionBlock'

const InfoWithExpandableCardsComponent: React.FC<IAttributes> = (props) => {
  return (
    <ClientOnly>
      <InfoWithAccordion
        reverse={props.reverse}
        title={props.title}
        paragraph={typeof props.description === 'string' ? parse(props.description) : props.description}
        image={
          <LazyLoadImage src={props.iconUrl} alt="" width="88px" height="88px" style={{ objectFit: 'contain' }} />
        }
        presentation={props.presentation}
        tagline={props.tagline}
        sublabel={props.sublabel}
        background={props.background}
        callToAction={{
          text: props.ctaText,
          url: props.ctaLink,
          className: props.ctaClassName,
        }}
      >
        <Card
          title={props.card1Title}
          content={props.card1Description}
          iconUrl={props.showAccordionIcons ? props.card1IconUrl : ''}
          background={props.background}
        />
        <Card
          title={props.card2Title}
          content={props.card2Description}
          iconUrl={props.showAccordionIcons ? props.card2IconUrl : ''}
          background={props.background}
        />
        <Card
          title={props.card3Title}
          content={props.card3Description}
          iconUrl={props.showAccordionIcons ? props.card3IconUrl : ''}
          background={props.background}
        />
      </InfoWithAccordion>
    </ClientOnly>
  )
}

interface ICardProps extends Pick<IAttributes, 'background'> {
  title: string
  content: string
  iconUrl: string
}

const Card: React.FC<ICardProps> = (props) => {
  const [isOpened, setOpened] = React.useState(false)

  return (
    <OpenableCard
      opened={isOpened}
      onToggle={() => setOpened((v) => !v)}
      title={
        <Title>
          {props.iconUrl && <Icon src={props.iconUrl} />}
          <span>{props.title}</span>
        </Title>
      }
      background={props.background}
    >
      <Text type="body" useCompact>
        <span dangerouslySetInnerHTML={{ __html: props.content }} />
      </Text>
    </OpenableCard>
  )
}

const Title = styled.div`
  && {
    display: flex;
    align-items: center;
  }
`

const Icon = styled.img`
  margin-right: 16px;
  width: 32px;
  height: 32px;
  object-fit: contain;
`

export default InfoWithExpandableCardsComponent
